import { render, staticRenderFns } from "./SessionDetail.vue?vue&type=template&id=7b896a94"
import script from "./SessionDetail.vue?vue&type=script&lang=js"
export * from "./SessionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports